import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.bubble.css";
import { ReactComponent as Rectangle } from "../../../../assets/previewPage/Rectangle 41943.svg";
import { ReactComponent as Line } from "../../../../assets/previewPage/Line.svg";
import { ReactComponent as ContactIcon } from "../../../../assets/MainPage/addBlock/countDown/call.svg";
import { ReactComponent as Whatsapp } from "../../../../assets/MainPage/addBlock/countDown/whatsapp.svg";
import { ReactComponent as HeaderShareIcon } from "../../../../assets/previewPage/headerIcons/headershareicon.svg";
import { ReactComponent as ShareIcon } from "../../../../assets/previewPage/headerIcons/PaperPlaneTilt.svg";
import { ReactComponent as LanguageShareIcon } from "../../../../assets/previewPage/headerIcons/grommet-icons_language.svg";

// import "../../cards/GlobalHeadingStyles.css"; // Import the global heading styles
const baseUrl = process.env.REACT_APP_API_URL;

const HeaderTextCard = ({ item, styles, isSticky }) => {
  const [coloumValue, setColoumValue] = useState(null);
  const [stylesColoumValue, setStylesColoumValue] = useState(null);

  useEffect(() => {
    if (item?.coloum_value) {
      try {
        const parsedColoumValue = JSON.parse(item.coloum_value);
        setColoumValue(parsedColoumValue);
        if (parsedColoumValue?.avatar_outline) {
          const parsedStylesColoumValue = JSON.parse(
            parsedColoumValue.avatar_outline
          );
          setStylesColoumValue(parsedStylesColoumValue);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, [item]);

  // const applyClassesToHtml = (html) => {
  //   if (!html) return '';
  //   // Regular expression to match opening <h1>, <h2>, <h3>, <h4>, <h5>, <h6> tags
  //   const regex = /<h([1-6])[^>]*>/g;

  //   // Replace all opening <hX> tags with the corresponding class
  //   const updatedHtml = html.replace(
  //     regex,
  //     (match, capturedGroup) =>
  //       `<h${capturedGroup} class='custom-h${capturedGroup.toLowerCase()}'>`
  //   );

  //   return updatedHtml;
  // };

  const alignmentClass =
    coloumValue?.alignment === "left"
      ? "items-start"
      : coloumValue?.alignment === "right"
      ? "items-end"
      : "items-center";

  const justifyClass =
    coloumValue?.alignment === "left"
      ? "justify-start"
      : coloumValue?.alignment === "right"
      ? "justify-end"
      : "justify-center";

  const backgroundImageUrl = coloumValue?.backGroundImage
    ? baseUrl + "/profile/" + coloumValue?.backGroundImage
    : "";

  const calculateMarginTop = (size) => {
    switch (size) {
      case "75x75":
        return "mt-[36px]";
      case "100x100":
        return "mt-[48px]";
      case "125x125":
        return "mt-[59px]";
      case "150x150":
        return "mt-[70px]";
      default:
        return "mt-[36px]";
    }
  };

  const marginTopClass = calculateMarginTop(coloumValue?.avatar_size);

  const calculateTop = (size) => {
    switch (size) {
      case "75x75":
        return "top-[102px]";
      case "100x100":
        return "top-[88px]";
      case "125x125":
        return "top-[74px]";
      case "150x150":
        return "top-[60px]";
      default:
        return "top-[102px]";
    }
  };

  const TopClass = calculateTop(coloumValue?.avatar_size);

  const truncateTitle = (title) => {
    if (title?.length > 20) {
      return title.slice(0, 20) + "...";
    }
    return title;
  };

  return (
    <div className={`flex flex-col ${alignmentClass} w-full md:w-[303px]`}>
      {backgroundImageUrl ? (
        <div
          className={`bg-cover bg-center bg-no-repeat w-full h-36 object-cover relative`}
          style={{
            backgroundImage: `url(${backgroundImageUrl})`,
          }}
        >
          <div className={`flex ${justifyClass} px-[20px]`}>
            <img
              style={{
                borderStyle: stylesColoumValue?.outline_style,
                borderColor: stylesColoumValue?.outline_colour,
              }}
              className={`object-cover absolute ${TopClass} ${
                coloumValue?.avatar_size
                  ? coloumValue?.avatar_size === "75x75"
                    ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
                    : coloumValue?.avatar_size === "100x100"
                    ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
                    : coloumValue?.avatar_size === "125x125"
                    ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
                    : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
                  : coloumValue?.avatar_size === "75x75"
                  ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
                  : coloumValue?.avatar_size === "100x100"
                  ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
                  : coloumValue?.avatar_size === "125x125"
                  ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
                  : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
              } ${
                coloumValue?.avatar_shape
                  ? coloumValue?.avatar_shape === "rounded"
                    ? "rounded-lg"
                    : coloumValue?.avatar_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                  : coloumValue?.avatar_shape === "rounded"
                  ? "rounded-lg"
                  : coloumValue?.avatar_shape === "circle"
                  ? "rounded-full"
                  : "rounded-none"
              } ${
                stylesColoumValue
                  ? `${
                      stylesColoumValue?.outline_width === "8px"
                        ? "border-8"
                        : stylesColoumValue?.outline_width === "4px"
                        ? "border-4"
                        : stylesColoumValue?.outline_width === "2px"
                        ? "border-2"
                        : "border"
                    } border-${stylesColoumValue?.outline_style} border-[${
                      stylesColoumValue?.outline_colour
                    }]`
                  : ""
              }`}
              src={`${
                coloumValue?.image
                  ? baseUrl + "/profile/" + coloumValue?.image
                  : ""
              }`}
              alt="avatar"
              title="Avatar"
            />
          </div>
          <div
            className="flex justify-end pt-[26px] px-[20px]"
            style={{
              margin: "0 auto", // Center the content
            }}
          >
            <div
              className="flex"
              style={{
                gap: "8px",
                opacity: "0px",
              }}
            >
              <ShareIcon className="cursor-pointer" />
              <HeaderShareIcon className="cursor-pointer" />
              <LanguageShareIcon className="cursor-pointer" />
            </div>
          </div>
        </div>
      ) : (
        <div className={`w-full h-36 object-cover relative`}>
          <div className={`flex ${justifyClass} px-[20px]`}>
            <img
              style={{
                borderStyle: stylesColoumValue?.outline_style,
                borderColor: stylesColoumValue?.outline_colour,
              }}
              className={`object-cover absolute ${TopClass}  ${
                coloumValue?.avatar_size
                  ? coloumValue?.avatar_size === "75x75"
                    ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
                    : coloumValue?.avatar_size === "100x100"
                    ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
                    : coloumValue?.avatar_size === "125x125"
                    ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
                    : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
                  : coloumValue?.avatar_size === "75x75"
                  ? "max-h-[75px] min-h-[75px] h-[75px] max-w-[75px] min-w-[75px] w-[75px]"
                  : coloumValue?.avatar_size === "100x100"
                  ? "max-h-[100px] min-h-[100px] h-[100px] max-w-[100px] min-w-[100px] w-[100px]"
                  : coloumValue?.avatar_size === "125x125"
                  ? "max-h-[125px] min-h-[125px] h-[125px] max-w-[125px] min-w-[125px] w-[125px]"
                  : "max-h-[150px] min-h-[150px] h-[150px] max-w-[150px] min-w-[150px] w-[150px]"
              } ${
                coloumValue?.avatar_shape
                  ? coloumValue?.avatar_shape === "rounded"
                    ? "rounded-lg"
                    : coloumValue?.avatar_shape === "circle"
                    ? "rounded-full"
                    : "rounded-none"
                  : coloumValue?.avatar_shape === "rounded"
                  ? "rounded-lg"
                  : coloumValue?.avatar_shape === "circle"
                  ? "rounded-full"
                  : "rounded-none"
              } ${
                stylesColoumValue
                  ? `${
                      stylesColoumValue?.outline_width === "8px"
                        ? "border-8"
                        : stylesColoumValue?.outline_width === "4px"
                        ? "border-4"
                        : stylesColoumValue?.outline_width === "2px"
                        ? "border-2"
                        : "border"
                    } border-${stylesColoumValue?.outline_style} border-[${
                      stylesColoumValue?.outline_colour
                    }]`
                  : ""
              }`}
              src={`${
                coloumValue?.image
                  ? baseUrl + "/profile/" + coloumValue?.image
                  : ""
              }`}
              alt="avatar"
              title="Avatar"
            />
          </div>

          <div
            className="flex justify-end pt-[26px] px-[20px]"
            style={{
              margin: "0 auto", // Center the content
            }}
          >
            <div
              className="flex"
              style={{
                gap: "8px",
                opacity: "0px",
              }}
            >
              <ShareIcon className="cursor-pointer" />
              <HeaderShareIcon className="cursor-pointer" />
              <LanguageShareIcon className="cursor-pointer" />
            </div>
          </div>
        </div>
      )}
      <h1
        className={`text-[30px] font-bold tracking-[-0.2px] px-[20px] ${marginTopClass} text-white text-center leading-[59.8px]`}
      >
        {truncateTitle(coloumValue?.pageName)}
      </h1>
      <h3 className="text-sm font-bold tracking-[-0.5px] text-main_color text-center px-[20px]">
        {truncateTitle(coloumValue?.pageTitle)}
      </h3>
      {/* <div className="ql-editor"> 
      <div
        className="tracking-[-0.5px] mt-2 text-center text-white"
        dangerouslySetInnerHTML={{
          __html: applyClassesToHtml(coloumValue?.description),
        }}
      ></div>
      </div> */}
      {coloumValue?.description && (
        <div className="text-white px-[5px]">
          <ReactQuill
            value={coloumValue?.description}
            readOnly={true}
            theme={"bubble"}
            style={{ border: "none" }}
          />
        </div>
      )}
      {/* <div
        style={{
          width: "100%",
          height: "151px",
          padding: "8px 24px 20px 24px",
          gap: "8px",
          borderRadius: "0px 0px 30px 30px",
          background: "rgba(255, 255, 255, 1)",
          boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.06)",
          boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.04)",
        }}
      >
        <div className="flex items-center justify-center mt-2">
          <Rectangle />
        </div>
        <div className="flex items-center justify-center text-small1_bold mt-2">
          Contact
        </div>
        <div className="flex items-center justify-center mt-2">
          <Line />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="flex items-center mt-2">
            <ContactIcon style={{ marginRight: "5px" }} />
            {coloumValue?.contact && <div>{coloumValue?.contact}</div>}
          </div>
          <div className="flex items-center mt-2">
            <Whatsapp style={{ marginRight: "5px" }} />
            {coloumValue?.whatsapp && <div>{coloumValue?.whatsapp}</div>}
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default HeaderTextCard;
